import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export const ImagenPlaca = () => {
  const { asistencia} = useSelector((state) => state.asistenciasReducer);

  const { asistenciaID } = useParams();
  const [imagenUrl, setImagenUrl] = useState(null);
  const token = localStorage.getItem("token");
  
  useEffect(() => {
    const obtenerImagen = async () => {
      try {
        const response = await axios.get(
          `https://qa-sigsa.backend.escotel.mx/api/Placas/${asistenciaID}`,
          {
            responseType: "blob", // 👈 importante para recibir archivo binario
            headers: {
              Authorization: `Bearer ${token}`, // 👈 tu token JWT
            },
          }
        );

        // Crear una URL temporal a partir del blob
        const url = URL.createObjectURL(response.data);
        setImagenUrl(url);
      } catch (error) {
        console.error("Error al cargar la imagen:", error);
      }
    };

    obtenerImagen();
  }, [asistencia]);

  return (
    <div>
      {imagenUrl && (
        <img
          src={imagenUrl}
          alt="Imagen de la placa"
          className="zoom-overlay"
        />
      )}
    </div>
  );
};
